import { render, staticRenderFns } from "./LandingPageCardColumn.vue?vue&type=template&id=7678f840&scoped=true"
import script from "./LandingPageCardColumn.vue?vue&type=script&lang=js"
export * from "./LandingPageCardColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7678f840",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingList: require('/src/components/landing/LandingList.vue').default})
